import React from 'react';

const Donations: React.FC = () => {
  return (
    <div className="min-h-screen py-16">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12 text-pakistan-green">
          Make a Donation
        </h1>
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-lg p-8 shadow-lg">
            <h3 className="text-2xl font-bold mb-6">Support Our Mission</h3>
            <p className="text-gray-600 mb-6">
              Your donation helps us create jobs, provide education, and support healthcare initiatives across Pakistan.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
              <button className="bg-green-100 text-green-800 p-4 rounded-lg font-semibold hover:bg-green-200">
                ₨500
              </button>
              <button className="bg-green-100 text-green-800 p-4 rounded-lg font-semibold hover:bg-green-200">
                ₨1,000
              </button>
              <button className="bg-green-100 text-green-800 p-4 rounded-lg font-semibold hover:bg-green-200">
                ₨2,500
              </button>
              <button className="bg-green-100 text-green-800 p-4 rounded-lg font-semibold hover:bg-green-200">
                ₨5,000
              </button>
            </div>
            <button 
              className="w-full bg-gray-500 text-white py-3 rounded-lg font-semibold cursor-not-allowed opacity-75"
              disabled
            >
              Soon Available
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Donations;
